$(function () {
    "use strict";

    var $form = $('.js-form'),
        $form_wrapper = $form.parent('.form_parent'),
        hasError = false,

        // csrf
        $tokenInputField = $form.find('#token'),
        postTokenName = $tokenInputField.attr('name'),
        postTokenValue = $tokenInputField.val(),

        // form fields
        $name = $form.find('[name=name]'),
        $names_ = $form.find('[name=names_]'),
        $email = $form.find('[name=email]'),
        $phone = $form.find('[name=phone]'),
        $message = $form.find('[name=message]'),
        $submit = $form.find('[name=submit]');

    $form.on('submit', function (event) {
        event.preventDefault();

        $form.find('.form-control').prop("disabled", true);
        $form.find('.error').remove();
        $form.find('.field_error').removeClass('field_error');
        hasError = false;

        $submit.addClass('loading');

        if ($name.val() === '') {
            $name.addClass('field_error');
            $name.after("<span class='error'>Моля, попълнете Вашите имена!</span>")
            hasError = true;
        }

        if (!isValidEmail($email.val())) {
            $email.addClass('field_error');
            $email.after("<span class='error'>Въведете валиден имейл!</span>")
            hasError = true;
        }

        if ($phone.val() === '') {
            $phone.addClass('field_error');
            $phone.after("<span class='error'>Моля, въведете Ваш телефон за контакт</span>")
            hasError = true;
        }

        if (hasError) {
            $form.find('.form-control').prop("disabled", false);
            $submit.removeClass('loading');

            return false;
        }

        var url = $form.prop('action');
        var recaptchaActionLabel = url.replace(/\W+/g, '_');

        grecaptcha.ready(function () {
            grecaptcha.execute(recaptcha_sitekey, {action: recaptchaActionLabel}).then(function (token) {
                var data = {
                    name: $name.val() || '',
                    names_: $names_.val() || '',
                    email: $email.val() || '',
                    phone: $phone.val() || '',
                    message: $message.val() || '',
                    recaptcha_response: token,
                    submit: $submit.val() || ''
                };

                $.ajax({
                    url: url,
                    method: 'POST',
                    beforeSend: function (request) {
                        request.setRequestHeader("X-" + postTokenName, postTokenValue);
                    },
                    data: data,
                    dataType: 'json'
                })
                    .done(function (data, textStatus, jqXHR) {
                        console.log('Form result: ', data);

                        if (data.error) {
                            $form.find('.error').remove();
                            $form.find('.field_error').removeClass('field_error');

                            $.each(data.errors, function (field, msg) {
                                var $field = $('#' + field);
                                $field.addClass('field_error');
                                $field.after("<span class='error'>" + msg + "</span>");
                            });

                        } else {
                            // success
                            if (data.message) {
                                $form_wrapper.slideUp(400, function () {
                                    $form_wrapper.html(data.message);
                                    $form_wrapper.slideDown(300);
                                });
                            }
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        console.log('ajax failed', textStatus);
                        alert(textStatus);
                    })
                    .always(function (datajqXHR, textStatus, jqXHRerrorThrown) {
                        $form.find('.form-control').prop("disabled", false);
                        $submit.removeClass('loading');
                    });
            });
        });
    });
});
